import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQuerySeatSelectionData =
  Content.Components['TransportSeatingModuleDto'];

interface UseQuerySeatSelectionOptions {
  initialData?: UseQuerySeatSelectionData;
  parameters: Content.Components['IBookingHeadlessParameters'] & {
    id: string;
    pageId: string;
  };
}

const useQuerySeatSelection = ({
  initialData,
  parameters,
}: UseQuerySeatSelectionOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQuerySeatSelectionData>(
    [QueryId.SEAT_SELECTION, parameters, locale],
    async () => {
      const baseUrl = '/api/content-modules/seat-selection';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQuerySeatSelection', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQuerySeatSelection;
